'use client';
import './FuelCostsSavingsCalculator.scss';
import React, { useState } from 'react';
import { getMonthlyAndYearlySavings } from '../../../../utils/getMonthlyAndYearlySavings';
import FuelCostsSavingsCalculatorSliders from './FuelCostsSavingsCalculatorSliders/FuelCostsSavingsCalculatorSliders';
import AverageConsumption from './AverageConsumption/AverageConsumption';
import Savings from './Savings/Savings';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
export default function FuelCostsSavingsCalculator({ fields }) {
  const [averageConsumptionValue, setAverageConsumptionValue] = useState(
    fields?.carsAverageConsumption?.fields?.defaultValue?.value
  );
  const [dailyCommuteValue, setDailyCommuteValue] = useState(
    fields?.dailyCommute?.fields?.defaultValue?.value
  );
  const ITEMS = fields?.carModel.map((el, index) => ({
    ...el,
    index,
  }));
  const [tab, setTab] = useState(ITEMS[0]);
  const [fuelPrice, setFuelPrice] = useState(tab.value);
  const { monthlyPhevSavings, yearlyPhevSavings } = getMonthlyAndYearlySavings(
    dailyCommuteValue,
    averageConsumptionValue,
    fuelPrice
  );

  const handleChangeTab = (index) => {
    const newTab = ITEMS.find((el) => el.index === index) ?? tab;
    setTab(newTab);
  };

  const handleChangeAverageConsumption = (value) => {
    setAverageConsumptionValue(value);
  };

  const handleChangeDailyCommute = (value) => {
    setDailyCommuteValue(value);
  };

  const handleChangeFuelPrice = (value) => {
    setFuelPrice(value);
  };
  return (
    <div className={'container FuelCostsSavingsCalculator wrapper'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'top'}>
          <div className={'top_title'} data-aos="fade-up">
            <RichText field={fields?.title} />
          </div>
          <div className={'top_text'} data-aos="fade-up">
            <RichText field={fields?.subTitle} />
          </div>
        </div>
        <div className={'cards'}>
          <Savings
            fields={fields}
            monthlyPhevSavings={monthlyPhevSavings}
            yearlyPhevSavings={yearlyPhevSavings}
          />
          <FuelCostsSavingsCalculatorSliders
            fields={fields}
            averageConsumptionValue={averageConsumptionValue}
            dailyCommuteValue={dailyCommuteValue}
            onChangeAverageConsumption={handleChangeAverageConsumption}
            onChangeDailyCommute={handleChangeDailyCommute}
          />
          <AverageConsumption
            tab={tab}
            fields={fields}
            ITEMS={ITEMS}
            onChangeTab={handleChangeTab}
            onChange={handleChangeFuelPrice}
          />
        </div>
      </div>
    </div>
  );
}
